import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { LocationTracker } from "@repo/helpers";
import GoogleMapReact from "google-map-react";
import { MutableRefObject, ReactNode } from "react";

export interface MapMarker {
	lat: number;
	lng: number;
	name: string;
	text?: string;
}

export interface Props {
	apiKey: string;
	options: GoogleMapReactMapOptions;
	showCurrentLocationMarker?: boolean;
	centerOnCurrentLocation?: boolean;
	center?: GoogleMapReactCoords;
	initialZoomLevel?: number;
	markers?: MapMarker[];
	locationTracker?: LocationTracker;
	markersToCenterOn?: string[];
	accuracyCircleRef?: MutableRefObject<any>;
	customControlButtons?: CustomControlButton[];
	setMapRef: (ref?: HTMLElement) => void;
	children?: ReactNode;
}

export interface MarkerProps {
	lat: number;
	lng: number;
	icon?: IconDefinition;
	color?: string;
	size?: SizeProp;
	text?: string;
	className?: string;
}

export interface BaseState {}

export interface CustomControlButton {
	icon: any;
	color: string;
	location: ControlPosition;
	onClick: (ref?: any) => void;
}

export enum ControlPosition {
	TOP_LEFT = "TOP_LEFT",
	TOP_CENTER = "TOP_CENTER",
	TOP_RIGHT = "TOP_RIGHT",
	BOTTOM_LEFT = "BOTTOM_LEFT",
	BOTTOM_CENTER = "BOTTOM_CENTER",
	BOTTOM_RIGHT = "BOTTOM_RIGHT",
	CENTER_LEFT = "LEFT_CENTER",
	CENTER_RIGHT = "RIGHT_CENTER",

	//      LEGEND
	// +----------------+
	// + TL    TC    TR +
	// +                +
	// + CL          CR +
	// +                +
	// + BL    BC    BR +
	// +----------------+
	// https://developers.google.com/maps/documentation/javascript/reference/control#ControlPosition
}

export interface GoogleMapReactCoords extends GoogleMapReact.Coords {}
export interface GoogleMapReactMapOptions extends GoogleMapReact.MapOptions {}
